import React from "react";
import { motion } from "framer-motion";
import aboutImage from "../assets/StartFilm.png"; 

// Animation Variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.3 },
  },
};

const textVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: { 
    opacity: 1, 
    x: 0, 
    transition: { duration: 0.8, ease: [0.215, 0.61, 0.355, 1] } 
  },
};

const imageVariants = {
  hidden: { 
    opacity: 0, 
    scale: 1.1 // Starts slightly zoomed in
  },
  visible: { 
    opacity: 1, 
    scale: 1, // Settles into original size
    transition: { 
      duration: 1.8, // Slightly longer for a luxurious feel
      ease: [0.33, 1, 0.68, 1] // Custom cubic-bezier for a smooth deceleration
    } 
  },
};

export default function About() {
  return (
    <motion.main 
      className="about-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {/* Subtle Background Decoration */}
      {/* <div className="bg-number">1951</div> */}

      <section className="about-container">
        {/* LEFT CONTENT */}
        <div className="about-text">
          <motion.h2 variants={textVariants} className="about-title">
            About Us  
          </motion.h2>

          <div className="scroll-content">
            <motion.p variants={textVariants}>
              Sippy Films is an independent studio focused on producing,
              financing, and distributing premium content for a global audience.
                Founded in 1951 by legendary film producer G. P. Sippy, the studio 
              has produced many of Indian cinema’s most memorable films
              over seven decades, including <em>Seeta Aur Geeta, Sholay, Shaan,</em> and <em>Saagar.</em>
                    The company has launched many of today’s stars and acting legends
              including Shah Rukh Khan, Rajesh Khanna, Babita Kapoor, and Raveena Tandon.
            </motion.p>


            <motion.p variants={textVariants}>
              In 1975, the company released Sholay the first Indian film in 70mm 
              along with stereophonic six-track sound, pushing the boundaries of technology.
            </motion.p>

            <motion.p variants={textVariants} >
              Today, Sippy Films strives to continue the vision its founder
              established, introducing new talent and pushing storytelling through innovation.
            </motion.p>
          </div>
        </div>

        {/* RIGHT IMAGE - MASK REVEAL */}
        <div className="about-image-wrapper">
          <motion.div className="image-reveal-container" variants={imageVariants}>
            <img src={aboutImage} alt="Sippy Films legacy collage" className="parallax-img" />
          </motion.div>
          {/* Decorative Frame */}
          <div className="image-frame" />
        </div>
      </section>

      {/*<motion.footer 
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        transition={{ delay: 1.5 }}
        className="about-footer"
      >
        © 2026 Sippy Films Pvt. Ltd.
      </motion.footer>*/}

      <style>{`
        .about-page {
          background-color: #050505;
          color: #fff;
          min-height: 100vh;
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          padding: 100px 5% 0;
        }

        .bg-number {
          position: absolute;
          font-size: 25vw;
          font-weight: 900;
          color: rgba(255, 255, 255, 0.02);
          bottom: -5%;
          left: -5%;
          user-select: none;
          pointer-events: none;
        }

        .about-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
          max-width: 1400px;
          margin: auto;
          z-index: 2;
        }

        .about-title {
          font-size: clamp(3rem, 5vw, 5rem);
          text-transform: uppercase;
          letter-spacing: -2px;
          margin-bottom: 40px;
          line-height: 1;
        }

        .gold-dot { color: #0093c0; }

        .about-text p {
          font-size: 1.1rem;
          line-height: 1.4;
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 25px;
          max-width: 550px;
        }

        .about-text strong { color: #fff; }

        .vision-text {
          border-left: 2px solid  #0093c0;
          padding-left: 20px;
          color: #fff !important;
          font-style: italic;
        }

        .about-image-wrapper {
          position: relative;
          width: 100%;
          height: 70vh;
        }

        .image-reveal-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* Remove the box-shadow if you want it cleaner, or soften it: */
  box-shadow: 0 30px 60px rgba(0,0,0,0.8);
  background-color: #000; /* Prevents white flash before image loads */
}

.parallax-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(20%); /* Optional: adds a vintage touch that fits "Legacy" */
  transition: filter 2s ease;
}

.about-page:hover .parallax-img {
  filter: grayscale(0%); /* Colors come to life when interacting */
}

        .image-frame {
          position: absolute;
          inset: -20px;
          border: 1px solid #0093c0;
          z-index: -1;
          pointer-events: none;
        }

        .about-footer {
          position: absolute;
          bottom: 1px;
          left: 50%;
          transform: translateX(-50%);
          color: #ffffffb3;
          font-size: 0.7rem;
          letter-spacing: 2px;
          opacity: 0.5;
        }

        @media (max-width: 1024px) {
          .about-container { grid-template-columns: 1fr; padding: 90px 0; }
          .about-image-wrapper { height: 400px; order: -1; }
          .about-footer{  font-size: 0.6rem; !important}
        }
      `}</style>
    </motion.main>
  );
}